import { render } from "./App.vue?vue&type=template&id=54a9e8c6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=54a9e8c6&lang=scss"
script.render = render

export default script